import * as $runtime from "../runtime.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Orders$dClaimFOD$dClaimFODResult from "../Orders.ClaimFOD.ClaimFODResult/index.js";
import * as Restaumatic$dAddresses$dTypes from "../Restaumatic.Addresses.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const GetOrderingAvailabilityRequest = x => x;
const ClaimFODResponse = x => x;
const ClaimFODRequest = x => x;
const rPCMethodNameGetOrderingA = {rpcMethodName: v => "GetOrderingAvailabilityRequest"};
const rPCMethodNameClaimFODRequ = {rpcMethodName: v => "ClaimFODRequest"};
const newtypeGetOrderingAvailab = {Coercible0: () => {}};
const newtypeClaimFODResponse_ = {Coercible0: () => {}};
const newtypeClaimFODRequest_ = {Coercible0: () => {}};
const hasFieldGetOrderingAvaila = dictHasField => dictHasField;
const hasFieldClaimFODResponse = dictHasField => dictHasField;
const hasFieldClaimFODRequest = dictHasField => dictHasField;
const eqGetOrderingAvailability = {eq: x => y => x.isQrWaiterOrder === y.isQrWaiterOrder && x.restaurantId === y.restaurantId};
const eqClaimFODResponse = {eq: x => y => x.id === y.id && Orders$dClaimFOD$dClaimFODResult.eqClaimFODResult.eq(x.result)(y.result)};
const eqClaimFODRequest = {
  eq: x => y => x.email === y.email && x.phone === y.phone && x.restaurantId === y.restaurantId && (() => {
    if (x.streetAddress.tag === "Nothing") { return y.streetAddress.tag === "Nothing"; }
    if (x.streetAddress.tag === "Just") {
      if (y.streetAddress.tag === "Just") {
        return (() => {
          if (x.streetAddress._1.apartmentNumber.tag === "Nothing") { return y.streetAddress._1.apartmentNumber.tag === "Nothing"; }
          if (x.streetAddress._1.apartmentNumber.tag === "Just") {
            if (y.streetAddress._1.apartmentNumber.tag === "Just") { return x.streetAddress._1.apartmentNumber._1 === y.streetAddress._1.apartmentNumber._1; }
            return false;
          }
          return false;
        })() && x.streetAddress._1.city === y.streetAddress._1.city && x.streetAddress._1.street === y.streetAddress._1.street && x.streetAddress._1.streetNumber === y.streetAddress._1.streetNumber;
      }
      return false;
    }
    return false;
  })()
};
const genericGetOrderingAvailabilityRequest = {to: x => x, from: x => x};
const showGetOrderingAvailabilityRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["isQrWaiterOrder", v.isQrWaiterOrder ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "restaurantId",
            Data$dShow.showIntImpl(v.restaurantId)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "GetOrderingAvailabilityRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetOrderingAvailabilityRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "isQrWaiterOrder"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "restaurantId"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericClaimFODResponse = {to: x => x, from: x => x};
const showClaimFODResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["id", Data$dShow.showStringImpl(v.id)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "result",
            Orders$dClaimFOD$dClaimFODResult.showClaimFODResult.show(v.result)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ClaimFODResponse"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeClaimFODResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "id"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "result"
    })(Orders$dClaimFOD$dClaimFODResult.unscrambleDecodeClaimFODResult)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericClaimFODRequest = {to: x => x, from: x => x};
const showClaimFODRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["email", Data$dShow.showStringImpl(v.email)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "phone",
            Data$dShow.showStringImpl(v.phone)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["restaurantId", Data$dShow.showIntImpl(v.restaurantId)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "streetAddress",
            (() => {
              if (v.streetAddress.tag === "Just") { return "(Just " + Restaumatic$dAddresses$dTypes.showStreetAddressWithApartment.show(v.streetAddress._1) + ")"; }
              if (v.streetAddress.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ClaimFODRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeClaimFODRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "email"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "phone"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "streetAddress"
    })(Unscramble.decodeMaybe(Restaumatic$dAddresses$dTypes.unscrambleDecodeStreetAddressWithApartment))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeGetOrderingAvailabilityRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "GetOrderingAvailabilityRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "restaurantId"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "isQrWaiterOrder"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeClaimFODResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericClaimFODResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "ClaimFODResponse"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "result"})({
      encodeWithOptions: v => Orders$dClaimFOD$dClaimFODResult.encodeClaimFODResult.encode
    }))({reflectSymbol: () => "id"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeClaimFODRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericClaimFODRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "ClaimFODRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "streetAddress"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dAddresses$dTypes.encodeStreetAddressWithApartment.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "restaurantId"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "phone"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "email"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeGetOrderingAvailabilityRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetOrderingAvailabilityRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "restaurantId"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "isQrWaiterOrder"})({
    decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeClaimFODResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericClaimFODResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ClaimFODResponse"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "result"
  })({decodeWithOptions: v => Orders$dClaimFOD$dClaimFODResult.decodeClaimFODResult.decode})())({reflectSymbol: () => "id"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeClaimFODRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericClaimFODRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ClaimFODRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "streetAddress"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dAddresses$dTypes.decodeStreetAddressWithApartment.decode)})())({
    reflectSymbol: () => "restaurantId"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "phone"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "email"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ClaimFODRequest,
  ClaimFODResponse,
  GetOrderingAvailabilityRequest,
  decodeClaimFODRequest,
  decodeClaimFODResponse,
  decodeGetOrderingAvailabilityRequest,
  encodeClaimFODRequest,
  encodeClaimFODResponse,
  encodeGetOrderingAvailabilityRequest,
  eqClaimFODRequest,
  eqClaimFODResponse,
  eqGetOrderingAvailability,
  genericClaimFODRequest,
  genericClaimFODResponse,
  genericGetOrderingAvailabilityRequest,
  hasFieldClaimFODRequest,
  hasFieldClaimFODResponse,
  hasFieldGetOrderingAvaila,
  newtypeClaimFODRequest_,
  newtypeClaimFODResponse_,
  newtypeGetOrderingAvailab,
  rPCMethodNameClaimFODRequ,
  rPCMethodNameGetOrderingA,
  showClaimFODRequest,
  showClaimFODResponse,
  showGetOrderingAvailabilityRequest,
  unscrambleDecodeClaimFODRequest,
  unscrambleDecodeClaimFODResponse,
  unscrambleDecodeGetOrderingAvailabilityRequest
};
